import { EonSparkVersion } from '@repo/api-gw-sdk';

export interface CreateSparkEngineWizardState {
  workspaceId: string;
  workspaceCloud: string;
  // Step 1: Details
  name: string;
  eonSparkVersion: EonSparkVersion;
  // Step 2: Resource Allocation
  maxVcpu: number;
  maxMemory: number;
  maxStorage: number;
  // Warm Capacity (optional toggle)
  warmCapacityEnabled: boolean;
  warmVcpu: number;
  warmMemory: number;
  warmStorage: number;
  // Job Limits (optional)
  concurrentJobs: number | null;
  queueTimeout: number | null;
  // Custom Image (optional)
  customImage: string;
  // IAM Role (AWS only)
  iamRoleArn: string;
  // Advanced
  showAdvanced: boolean;
  instanceFamily: string | null;
  dedicatedResources: boolean;
}

export const defaultCreateSparkEngineWizardState: CreateSparkEngineWizardState =
  {
    workspaceId: '',
    workspaceCloud: '',
    name: '',
    eonSparkVersion: EonSparkVersion.EON_SPARK_VERSION_1_0,
    maxVcpu: 4,
    maxMemory: 16,
    maxStorage: 100,
    warmCapacityEnabled: false,
    warmVcpu: 1,
    warmMemory: 4,
    warmStorage: 50,
    concurrentJobs: null,
    queueTimeout: null,
    customImage: '',
    iamRoleArn: '',
    showAdvanced: false,
    instanceFamily: null,
    dedicatedResources: false,
  };
